// @flow
import styled from "styled-components"
import { mq } from "common/mediaQuery"

export const Offset = styled.div`
  padding-left: 1.6rem;

  ${mq.tabletWide} {
    padding: 0;
    max-width: 56rem;
    margin: 0 auto;
  }
`



// WEBPACK FOOTER //
// ./src/componentsStyled/Layout/Offset.js